/// <summary>
/// Author :
/// API related key or field when making ajax or api call
/// </summary>

export class ApiKey {
    static _API_SUCCESS_KEY = "success";
    static _API_MESSAGE_KEY = "message";
    static _API_DATA_KEY = "data";
    static _API_CODE_KEY = "code";
    static _API_CONTENT_TYPE = "Content-Type";
    static _API_ACCEPT = "Accept";
    static _API_APPLICATION_JSON = "application/json";
    static _API_XML_HTTP_REQUEST_KEY = "XMLHttpRequest";
    static _API_FORM_URLENCODED = "application/x-www-form-urlencoded";
    static _API_POST = "POST";
    static _API_GET = "GET";
}

/// <summary>
/// Author :
/// Url to communicate to controller
/// </summary>
export class ApiUrl {
    /* AccountController - start */
    static _API_LOGIN = "/Account/Login";
    static _API_LOGOUT = "/Account/Logout";
    static _API_IS_LOGGED_IN = "/Account/IsLoggedIn";
    static _API_GET_USER_PAYMENT_GATEWAY_INFO = "/Account/GetPaymentGatewayInfo";
    static _API_SEND_RESET_PASSWORD_SMS = "/Account/SendResetPasswordSms";
    static _API_CREATE_OR_UPDATE_MEMBER = "/Account/CreateOrUpdateMember";
    static _API_CREATE_OR_UPDATE_MEMBER_2 = "/Account/CreateOrUpdateMember2";
    static _API_UPDATE_MEMBER_USERFULLNAME = "/Account/UpdateMemberUserFullname";
    static _API_GET_USER_ANNOUNCEMENT = "/Account/GetUserAnnouncement";
    static _API_GET_COMPANY_CONTACT_US = "/Account/GetCompanyContactUs";
    static _API_VERIFY_RESET_PASSWORD_SMS = "/Account/VerifyResetPasswordSms";
    static _API_UG_GET_ACTIVE_GAME_CATEGORY = "/UG/UGGetActiveGameCategory";

    static _API_UPDATE_USER_DATA = "/Account/UpdateUserData";

    static _API_GET_LOGIN_FAILED_COUNT = "/Account/GetLoginFailCount";
    static _API_GET_DEPOSIT_FAILED_COUNT = "/Account/GetDepositFailCount";
    static _API_MANAGE_MEMBER_LOGIN_FAIL_COUNT =
        "/Account/ManageMemberLoginFailCount";

    /*static _API_ADD_OPERATION_LOG = "/Account/AddOperationLog";*/
    static _API_GET_WALLET_TRANSFER = "/Account/GetWalletTransfer";

    static _API_CHECK_MEMBER_ROLLOVER = "/Member/CheckMemberRollover";

    static _API_GET_COMPANY_CONTENT_LANGUAGE =
        "/Account/GetCompanyContentLanguage";
    static _API_GET_MEMBER_WALLET_BALANCE = "/Account/GetMemberWalletBalance";
    /* AccountController - end */

    /* MemberController - start */
    static _API_GET_MEMBER_DETAILS_BY_ID = "/Member/GetMemberDetailsById";
    static _API_GET_MEMBER_SPIN_WHEEL = "/Member/SpinWheel";
    static _API_GET_MEMBER_DOWNLINE_GAMES_BY_MASTERPRODUCT = "/Member/GetMemberDownlineGameByMasterProduct";
    static _API_UPDATE_DOWNLINE_MEMBER_GAME = "/Game/UpdateDownlineMemberGame";
    static _API_GET_MEMBER_DETAILS_DASHBOARD = "/Member/GetMemberDetailsDashboard";
    static _API_GET_NOTIFICATION_LIST = "/Member/GetNotificationList";
    static _API_GET_UNREAD_NOTIFICATION_LIST = "/Member/GetUnreadNotificationList";
    static _API_GET_VIDEO = "/Member/GetVideo";
    static _API_MEMBER_RESET_PASSWORD = "/Member/ResetPassword";
    static _API_MEMBER_RESET_PASSWORD_BEFORE_LOGIN = "/Member/ResetPasswordBeforeLogin";
    static _API_GET_ANNOUNCEMENT = "/Member/GetAnnouncement";
    static _API_MARK_ANNOUNCEMENT_AS_READ = "/Member/MarkAnnouncementRead";
    static _API_GET_USER_MEMBERS = "/Member/GetUserMember";
    static _API_GET_USER_MEMBER_LIST = "/Member/GetUserMemberList";
    static _API_GET_MEMBER_PRODUCT_RATES = "/Member/GetMemberProductRates";
    static _API_GET_MEMBER_REFERRAL_PRODUCT_RATES = "/Member/GetMemberReferralProductRates";
    static _API_GET_MEMBER_UPLINE_PRODUCT_RATES = "/Member/GetUplineProductRates";
    static _API_GET_MEMBER_REFERRAL_CODES = "/Member/GetMemberReferralCodes";
    static _API_DEL_REFERRAL = "/Member/DelMemberReferralCode";
    static _API_GENERATE_MEMBER_REFERRAL_CODE = "/Member/GenerateReferralCode";
    static _API_GET_UPLINE_BY_REFERRAL_CODE = "/Member/GetUplineByReferralCode";
    static _API_CHECK_USERNAME = "/Member/CheckUsername";
    static _API_GET_MEMBER_SUMMARY_KPI = "/Member/GetMemberSummaryKpi";
    static _API_GET_MEMBER_DETAIL_KPI = "/Member/GetMemberKpiDetail";
    static _API_UPDATE_MEMBER_NICKNAME = "/Member/UpdateMemberNickname";
    static _API_CHECK_MEMBER_PIN_NUMBER = "/Member/CheckMemberPinNumber";
    static _API_SET_MEMBER_PIN_NUMBER = "/Member/SetMemberPinNumber";
    static _API_RESET_MEMBER_PIN_NUMBER = "/Member/ResetMemberPinNumber";
    static _API_CHECK_SHAREHOLDER_PIN_NUMBER =
        "/Member/CheckShareholderPinNumber";
    static _API_SET_SHAREHOLDER_PIN_NUMBER = "/Member/SetShareholderPinNumber";
    static _API_RESET_SHAREHOLDER_PIN_NUMBER =
        "/Member/ResetShareholderPinNumber";
    static _API_CHECK_IF_PHONE_VERIFIED = "/Member/CheckIfPhoneVerified";
    static _API_GET_COMPANY_SKIN_SETTINGS = "/Member/GetCompanySkinSettings";

    static _API_GET_MEMBER_PRODUCT_DETAILS = "/Member/GetMemberProductDetails";

    static _API_CREATE_OR_UPDATE_DOWNLINE_GROUP =
        "/Member/CreateOrUpdateDownlineGroup";
    static _API_ADD_OR_REMOVE_MEMBER_INTO_GROUP =
        "/Member/AddOrRemoveMemberIntoGroup";
    static _API_GET_DOWNLINE_GROUPS = "/Member/GetDownlineGroups";
    static _API_GET_DOWNLINE_GROUP_DETAIL_BY_ID =
        "/Member/GetDownlineGroupDetailById";
    static _API_DELETE_DOWNLINE_GROUP = "/Member/DeleteDownlineGroup";
    static _API_GET_UNGROUP_MEMBER_LIST = "/Member/GetUngroupMemberList";

    static _API_GET_UNCLAIM_COMMISSION_AMT = "/Member/GetUnclaimCommissionAmt";

    static _API_CHECK_HIDE_SUMMARY = "/Member/CheckHideSummary";

    static _API_GET_USER_FULLNAME = "/Member/GetUserFullName";
    static _API_GET_COMMUNICATION_CHANNELS = "/Member/GetCommunicationChannel";

    static _API_SEND_VERIFICATION_CODE = "/Member/SendVerificationCode";
    static _API_SEND_PIN_CODE = "/Member/SendPinCode";
    static _API_VERIFY_PHONE_NUMBER = "/Member/VerifyPhoneNumber";
    static _API_CHECK_DISPLAY_BANK_DETAIL = "/Bank/CheckBankDetails";

    static _API_GET_USER_BANNER = "/Member/GetUserBanner";
    static _API_MANAGE_BANNER_NOTIFICATION = "/Member/ManageBannerNotification";
    static _API_GET_PRODUCT_CATEGORY = "/Member/GetProductCategory";
    static _API_GET_PRODUCT_CATEGORY_DESKTOP =
        "/Member/GetProductCategoryDesktop";
    static _API_GET_PRODUCT_CATEGORY_WITH_MASTER_PRODUCT =
        "/Member/GetProductCategoryWithMasterProduct";
    static _API_GET_MASTER_PRODUCT_CATEGORY = "/Member/GetMasterProductCategory";
    static _API_GET_USER_VIP_LEVEL = "/Member/GetUserVipLevel";

    static _API_GET_MEMBER_SHAREHOLDER_DETAIL =
        "/Member/GetMemberShareholderDetail";
    static _API_GET_MEMBER_SHAREHOLDER_UNCLAIM =
        "/Member/GetMemberShareholderUnclaim";
    static _API_UPDATE_SHAREHOLDER = "/Member/UpdateShareholder";
    static _API_CLAIM_SHAREHOLDER = "/Member/ClaimShareholder";
    static _API_CLAIM_COMMISSION = "/Member/ClaimCommission";

    static _API_UPDATE_MEMBER_THEME = "/Member/UpdateMemberTheme";
    static _API_GET_MEMBER_FULLNAME = "/Member/GetMemberFullname";

    static _API_CHECK_PHONE_NUMBER = "/Member/CheckPhoneNumber";

    static _API_GET_COMPANY_TNG_SYSTEM_SETTINGS =
        "/Member/GetCompanyTnGSystemSettings";

    static _API_SEND_TAC_CODE = "/Member/SendTACCode";
    static _API_VERIFY_TAC_CODE = "/Member/VerifyTACCode";

    static _API_GET_USER_SYSTEM_SETTINGS = "/Member/GetUserSystemSettings";

    static _API_GET_CATEGORY_REWARD_RATES = "/Member/GetCategoryRewardRates";
    static _API_CHECK_IF_REFERRAL_CODE_EXIST = "/Member/CheckIfReferralCodeExist";
    static _API_CLAIM_REWARD = "/Member/ClaimReward";
    static _API_GET_USER_REWARD_BANNER = "/Member/GetUserRewardBanner";
    static _API_UPDATE_MEMBER_PHONE_NUMBER = "/Member/UpdateMemberPhoneNumber";
    static _API_UPDATE_MEMBER_LANGUAGE = "/Member/UpdateMemberLanguage";
    static _API_CHECK_IS_SHAREHOLDER = "Member/CheckIfIsShareholder";

    static _API_GET_REWARDS_SCHEDULES = "Member/GetRewardsSchedulesForMember";

    static _API_CHECK_MEMBER_INTERNAL_TRANSFER_LIMIT_BALANCE = "/Member/CheckInternalTransferLimitBalance";
    static _API_CHECK_MEMBER_WITHDRAWAL_LIMIT_BALANCE = "/Member/CheckWithdrawalLimitBalance";
    static _API_GET_COMPANY_PROMOTION = "/Member/GetCompanyPromotion";
    /* MemberController - end */

    /* TransactionController - start */
    static _API_GET_MEMBER_WALLET_STATEMENT =
        "/Transaction/GetMemberWalletStatement";
    static _API_GET_TRANSACTION_BY_MEMBER_ID =
        "/Transaction/GetTransactionByMemberId";
    static _API_GET_TRANSACTION_BY_MEMBER_DEPOSIT_AND_WITHDRAWAL =
        "/Transaction/GetTransactionByMemberDepositAndWithdrawal";
    static _API_GET_PENDING_TRANSACTION_BY_MEMBER_DEPOSIT_AND_WITHDRAWAL = "/transaction/GetPendingTransactionByMemberDepositAndWithdrawal";
    static _API_GET_ROLLOVER_RECORD = "/Transaction/GetRolloverRecord";
    static _API_CREATE_TRANSACTION = "/Transaction/CreateTransaction";
    static _API_GET_BONUS_HISTORY = "/Transaction/GetBonusHistory";
    static _API_GET_DEPOSIT_BONUS_HISTORY = "/Transaction/GetDepositBonusHistory";
    static _API_GET_INTERNAL_TRANSFER = "/Transaction/GetInternalTransferHistory";
    static _API_GET_COMMISSION_HISTORY = "/Transaction/GetCommissionHistory";
    static _API_GET_PENDING_TRANSACTION = "/Transaction/CheckPendingTransaction";
    static _API_GET_PENDING_TRANSACTION_DASHBOARD = "/Transaction/CheckPendingTransactionDashboard";
    static _API_GET_CLAIM_HISTORY = "/Transaction/GetClaimHistory";
    static _API_GET_VADERPAY_BANK_OPTION = "/Transaction/GetVaderPayBankOption";

    static _API_GET_BONUS_DEPOSIT = "/Transaction/GetBonusDeposit";
    static _API_GET_ACTIVE_BONUS_DEPOSIT_BY_ID = "/Transaction/GetAciveBonusDepositById";

    static _API_CREATE_WALLET_TRANSFER_TRANSACTION =
        "/Transaction/CreateWalletTransferTransaction";

    static _API_SPG_CHECK = "/Transaction/CheckSPG";
    static _API_GET_MEMBER_REWARD_HISTORY = "/Transaction/GetMemberRewardHistory";
    /* TransactionController - end */

    /* GameController - start */
    static _API_GET_GAME_RECORD_BY_MEMBER = "/Game/GetProductGameRecordByMember";
    static _API_GET_NON_SEAMLESS_PRODUCT_BALANCE =
        "/Game/GetNonSeamlessProductBalance";
    static _API_GET_ASSIGNED_MEMBER_PRODUCT = "/Game/GetAssignedMemberProduct";
    static _API_GET_ASSIGNED_MEMBER_PRODUCT_SHOW_LIST =
        "/Game/GetAssignedMemberProductShowList";
    static _API_UPDATE_MEMBER_PRODUCT_RATE = "/Game/UpdateMemberProductRate";
    static _API_UPDATE_DOWNLINE_PRODUCT_RATE = "/Game/UpdateDownlineProductRate";
    static _API_UPDATE_MEMBER_PRODUCT_ACTIVENESS =
        "/Game/UpdateMemberProductActiveness";
    static _API_GET_POOL_RESULT = "/Game/GetPoolResult";
    static _API_GET_LIVE_STREAMING_MATCHES = "/Game/GetLiveStreamingMatches";
    static _API_GET_LIVE_STREAMING_URL = "/Game/GetLiveStreamingUrl";
    static _API_REDUCE_LIVE_STREAMING_TIME = "/Game/ReduceLiveStreamingTime";
    static _API_GET_PRODUCT_WITH_MAX_RATE = "/Game/GetGroupedProductWithMaxRates";
    static _API_GET_CATEGORY_GROUP_GAME = "/Game/GetCategoryGroupedGame";
    static _API_GET_CATEGORY_GROUP_GAME_DASHBOARD =
        "/Game/GetCategoryGroupedGameDashboard";

    static _API_GET_MASTER_PRODUCT_GROUP_GAME =
        "/Game/GetMasterProductGroupedGame";
    static _API_GET_RECOMMENDED_MASTER_PRODUCT_GROUP_GAME =
        "/Game/GetRecommendedMasterProductGroupedGame";
    static _API_GET_MASTER_PRODUCT_BY_ID = "/Game/GetMasterProductById";

    static _API_CHECK_IF_NON_SEAMLESS = "/Game/CheckIfNonSeamless";
    static _API_CHANGE_PRODUCT_PASSWORD = "/Game/ChangeProductPassword";

    static _API_START_GAME = "/Game/StartGame";
    static _API_GET_BET_DETAILS = "/Game/GetProductGameRecordById";
    static _API_GET_FLAG_TRANSFER_BACK_MAIN_WALLET =
        "/Game/GetFlagTransferBackMainWallet";
    static _API_GET_PRODUCT_GAME_LIST = "/Game/GetProductGameList";

    static _API_GET_IS_NEW_MASTER_PRODUCT_GROUPED_GAME =
        "/Game/GetIsNewMasterProductGroupedGame";

    static _API_GET_IS_NEW_MASTER_PRODUCT_GROUPED_GAME_DESKTOP =
        "/Game/GetIsNewMasterProductGroupedGameDesktop";

    static _API_GET_CATEGORY_GROUPED_GAME_DASHBOARD_DESKTOP =
        "/Game/GetCategoryGroupedGameDashboardDesktop";

    static _API_GET_COMPANY_CONTENT = "/Game/GetCompanyContent";
    static _API_UG_GET_COMPANY_CONTENT = "/UG/UGGetCompanyContent";

    static _API_GET_WEB_CONTENT = "/Game/GetWebContent";

    static _API_GET_PRODUCT_GAME_LIST_BY_CATEGORY_ID = "/Game/GetProductGameListByCategoryId";

    static _API_GET_MINI_GAME_URL = "/Game/StartMiniGame";
    /* GameController - end */

    /* BankController - start */
    static _API_GET_MEMBER_BANK_ACCOUNT_BY_MEMBER =
        "/Bank/GetMemberBankAccountByMember";
    static _API_CREATE_OR_UPDATE_MEMBER_BANK_ACCOUNT =
        "/Bank/CreateOrUpdateMemberBankAccount";
    static _API_GET_USER_BANK = "/Bank/GetUserBank";
    static _API_GET_BANK_ACCOUNT = "/Bank/GetBankAccount2";
    static _API_GET_BANK_ACCOUNT_BY_BANK_ID = "/Bank/GetBankAccountByBankId";
    static _API_GET_BANK_LIST = "/Bank/GetBankList";

    static _API_GET_CHECK_FREE_SPIN_COUNT = "/Member/CheckIfMemberEligibleForFreeSpin";

    static _API_GET_MARQUEE_TAG_CONTENT = "/Member/GetMarqueeTagContent";

    static _API_GET_ALL_LOYALTY_ITEM = "/Member/GetAllLoyaltyItemForMember";
    static _API_GET_LOYALTY_ITEM_BY_ID = "/Member/GetLoyaltyItemByIdForMember";
    static _API_REDEEM_VOUCHER = "/Member/RedeemVoucher";
    static _API_REDEEM_LOYALTY_ITEM = "/Member/RedeemLoyaltyItem";
    static _API_GET_LOYALTY_REDEMPTION_HISTORY = "/Member/GetLoyaltyRedemptionHistory";
    static _API_CREATE_VOUCHER_TRANSACTION = "/Transaction/CreateVoucherTransaction";
    static _API_GET_UNCLAIM_LOYALTY_POINTS = "/Member/GetUnclaimLoyaltyPoints";
    static _API_CLAIM_LOYALTY_POINTS = "/Member/ClaimLoyaltyPoints"
    static _API_GET_LOYALTY_POINTS_HISTORY = "/Transaction/GetLoyaltyPointsHistory";
    static _API_GET_MEMBER_LOYALTY_POINTS_BY_ID = "/Member/GetMemberLoyaltyPointsById";
    static _API_GET_REGISTER_GAME_POINTS = "/Member/GetRegisterGamePoints"
    static _API_GET_DEPOSIT_GAME_POINTS = "/Member/GetDepositGamePoints"
    static _API_CREATE_GAME_POINTS_BONUS_RECORD = "/Member/CreateGamePointsBonusRecord"
    static _API_GET_GAME_POINT_CONTENT = "/Member/GetGamePointContent";


    /* BankController - end */

    static _API_SEND_EMAIL_VERIFICATION_CODE = "/Member/SendEmailVerificationCode";
    static _API_VERIFY_EMAIL = "/Member/VerifyEmail";
    static _API_UPDATE_MEMBER_EMAIL_AND_BIRTH_DATE = "/Account/UpdateMemberEmailAndBirthDate";

    //static _API_GET_REMAINING_CLAIMABLE_BONUS = "/Transaction/GetMemberClaimableBonus";

    static _API_GET_COMPANY_PROMPT_PAY_SYSTEM_SETTINGS = "/Member/GetCompanyPromptPaySystemSettings";
    static _API_GET_MEMBER_INTERNAL_TRANSFER_STATUS = "/Member/GetMemberInternalTransferStatus";
    static _API_GET_MEMBER_TEST_ACCOUNT_STATUS = "/Member/GetMemberTestAccountStatus";
    static _API_GET_DEPOSIT_TUTORIAL_CONTENT_LANGUAGE = "/Member/GetDepositTutorialContentLangauge";
    static _API_GET_DEPOSIT_TUTORIAL_CONTENT = "/Member/GetDepositTutorialContent";
    static _API_GET_MEMBER_TRANSACTION_HISTORY = "/Member/GetMemberTransactionHistoryByMemberId"

    static _URL_GET_568_RECOMMENDED_MATCHES = "/Game/Get568RecommendedMatches";
    static _API_GET_MEMBER_PRODUCT_DETAILS_SPORTS_BOOK = "/Member/GetMemberProductDetails568SportsBook";
    static _API_GET_MEMBER_IS_SPECIAL_ROLLOVER = "/Member/GetMemberIsSpecialRollover";
    static _API_GET_BONUS_DEPOSIT_PRODUCT_CATEGORY = "/Member/GetBonusDepositProductCategory";
    static _API_GET_MEMBER_CURRENT_ROLLOVER_BALANCE = "/Member/GetMemberCurrentRolloverBalance";
    static _API_GET_SEO_SCRIPTS = "/Account/GetSeoScript";
    static _API_GET_SEO_SCRIPTS_LANGUAGE = "/Account/GetSeoScriptLangauge";

    static _API_CHECK_MEMBER_DAILY_CHEKC_IN = "/Member/GetMemberDailyCheckIn";
    static _API_CREATED_CHECK_IN = "/Member/CreatedCheckIn";
    static _API_CHECK_DAILY_CHECK_IN_STATUS = "/Member/CheckDailyCheckInStatus";
    static _API_GET_MEMBER_PRODUCT_RATE = "/Member/GetMemberProductRate";

    /* UGController - start */
    static _API_UG_GET_POPULAR_GAMES = "/UG/UGGetPopularGames";
    static _API_UG_GET_LATEST_DEPOSIT_WITHDRAWAL_RECORD = "/UG/UGGetLatestDepositWithdrawalRecord";
    static _API_UG_GET_LATEST_WINNING_RECORD = "/UG/UGGetLatestWinningRecord";

    static _API_UG_GET_WITHDRAWAL_BANK_LIST = "/UG/UGGetWithdrawalBankList";
    static _API_UG_REGISTER_MEMBER = "/UG/UGRegisterMember";
    static _API_UG_CHECK_EMAIL = "/UG/UGCheckEmailAvailable";
    static _API_UG_GET_AVAILABLE_MASTER_PRODUCT_DESKTOP = "/UG/UGGetAvailableMasterProductDesktop";
    static _API_GET_MEMBER_REGISTERED_UNDER_CODE = "/Member/GetMemberRegisteredUnderCode";
    static _API_UG_GET_PRODUCT_GAMES_LIST = "/UG/UGGetProductGameList"
    static _API_GET_GAME_IS_NEW_WINDOW = "/Game/GetGameIsNewWindow";
    static _API_UG_CHECK_IS_SHAREHOLDER = "/UG/UGCheckIsShareholder";
    static _API_GET_IDR_PRODUCTION_LINK = "/UG/UGGetIdrProductionLink"
    static _API_GET_LAST_BONUS_DEPOSIT_ROLLOVER_RECORD = "/UG/GetLastBonusDepositRolloverRecord"
    static _API_GET_LAST_TRANSACTION_HISTORY = "UG/GetLastTransactionHistory";
    static _API_GET_FIRST_REFERRAL_CODE_BY_MEMBER_ID = "UG/GetFirstReferralCodeById";
    static _API_GET_IS_NON_SEAMLESS_GAME_EXIST = "UG/UGGetIsNonSeamlessGameExist";
    static _API_UG_GET_USER_BANNER = "/UG/UGGetUserBanner";
    static _API_GET_RTP_URL = "/Member/GetRTPUrl";
    static _API_GET_TOTAL_COMMISION_REWARD = "/UG/GetTotalCommisionAndReward"
    /* UGController - end */
    static _API_GET_WHATSAPP_PHONE = "/Member/GetWhatsAppPhone";
    static _API_GET_TELEGRAM_LINK = "/Member/GetTelegramRegisterLink";
    static _API_MARK_POPUP_BANNER_AS_READ = "/Member/MarkPopupBannerRead";
    static _API_UPDATE_MEMBER_NOTIFICATION = "/Member/UpdateMemberNotification";
    static _API_GET_MEMBER_BIG_WINNING = "/Member/GetMemberBigWinning";
    static _API_CHECK_DOWNLINE_DEPOSIT = "/Member/CheckDownlineDeposit";
    static _API_UPDATE_MEMBER_BIG_WINNING_VIEW_HISTORY_COUNT = "/Member/UpdateMemberBigWinningViewHistoryCount";
    static _API_GET_LATEST_WIN = "/UG/UGGetLatestWin";
    static _API_GET_LATEST_SPIN_WHEEL_WINNING_RECORD = "/Member/GetLatestSpinWheelWinningRecord";
    static _API_GET_SPIN_WHEEL_WINNING_RECORD = "/Member/GetSpinWheelWinningRecord";
    static _API_GET_CHAT_SPHERE_STATUS = "/Member/GetChatSphereStatus";


    static _API_UG_GET_DESKTOP_HOME_PAGE_GENERAL_DATA = "/UG/UGGetDesktopHomePageGeneralData";
    static _API_UG_GET_DESKTOP_HOME_PAGE_LANGUAGE_DATA = "/UG/UGGetDesktopHomePageLanguageData";
    static _API_UG_GET_DESKTOP_HOME_PAGE_AUTH_DATA = "/UG/UGGetDesktopHomePageAuthData";
    static _API_UG_GET_DESKTOP_HEADER_GENERAL_DATA = "/UG/UGGetDesktopHeaderGeneralData";
    static _API_UG_GET_DESKTOP_HEADER_AUTH_DATA = "/UG/UGGetDesktopHeaderAuthData";
    static _API_UG_GET_DESKTOP_HEADER_LANGUAGE_DATA = "/UG/UGGetDesktopHeaderLanguageData";
    static _API_GET_MEMBER_IS_SPECIAL_ROLLOVER_DATA = "/Member/GetMemberIsSpecialRolloverData";
    static _API_GET_PRODUCT_GAME_BY_GAME_ID = "/Game/GetProductGameByGameId";

    static _API_GET_INACTIVE_DOWNLINE_DETAIL = "/UG/GetInactiveDownlineDetail";
    static _API_GET_INACTIVE_DOWNLINE_DEPOSIT_LIMIT = "/UG/GetInactiveDownlineLimit";
    static _API_GET_TOTAL_INACTIVE_DOWNLINE = "/UG/GetTotalInactiveDownline";
    static _API_GET_ROLLOVER_BALANCE_DAILY_CHECK_IN = "/Member/GetRolloverBalance";
    static _API_CHECK_CHAT_SPHERE_URL = "/Member/CheckChatSphereUrl";

    static _API_GET_MEGATOTO_JACKPOT = "/Game/GetMegatotoJackpot";
    static _API_GET_MEGATOTO_QUICKBET_INFO = "/Game/GetMegatotoQuickbetInfo";
    static _API_PLACE_MEGATOTO_QUICKBET = "/Game/PlaceMega3dQuickBet";
    static _API_UG_GET_MEGATOTO_QUICKBET_STATUS = "/UG/UGGetMegatotoQuickbetStatus";
    static _API_GET_COMMISION_REWARD = "/UG/GetTotalCommisionAndReward";
    static _API_GET_LATEST_PAYOUT = "/UG/UGGetLatestWin";
    static _API_GET_PULSA_DEPOSIT_MULTIPLIER = "/UG/UGGetPulsaDepositMultiplier";
    static _API_GET_MEGATOGEL_DATA = "/Game/GetMegatogelData";
    static _API_GET_WORLD_CUP_EVENT_DETAIL = "/Member/GetWorldCupEventDetail";
    static _API_LOCKED_WORLD_CUP_MEMBER_PICK = "/Member/CreateOrUpdateWorldCupMemberPick";
    static _API_CREATED_WORLD_CUP_REWARD = "/Member/CreatedWorldCupReward";
    static _API_GET_WORLD_CUP_STATUS = "/Member/GetWorldCupStatus";
    static _API_GET_WINNER_RESULT_DETAIL = "/Member/GetWinnerResultDetail";
    static _API_CLAIM_WORLD_CUP_WINNER_PRIZE = "/Member/ClaimWorldCupWinnerPrize";
    static _API_GET_MEMBER_TRANSACTION_RECORD_UG = "/UG/GetMemberTransactionRecordUG";
    static _API_GET_PRODUCT_GAME_RECORD_BY_MEMBER_UG = "/UG/GetProductGameRecordByMemberUG";

}

/// <summary>
/// Author :
/// Url to navigate to pages
/// </summary>
export class WebUrl {
    static _URL_MAIN = "/";
    static _URL_HOME = "/home";
    static _URL_GAME_PROVIDER = "/game-provider/:title";
    static _URL_MAIN_WALLET = "/main-wallet";
    static _URL_DEPOSIT = "/deposit";
    //static _URL_DEPOSIT = "/depositEnhanced";
    static _URL_WITHDRAWAL = "/withdrawal";
    static _URL_TRANSACTION_HISTORY = "/transaction-history";
    static _URL_PENDING_TRANSACTION = "/pending-transaction";
    /* static _URL_TRANSFER = "/transfer";*/
    static _URL_NOTIFICATION = "/notification";
    static _URL_NOTIFICATION_DETAIL = "/notification-detail";
    static _URL_VIDEO_TUTORIAL = "/video-tutorial";
    static _URL_DOWNLINE = "/downline";
    static _URL_PROGRESS_COMM_RATE = "/progress-commission-rate";
    static _URL_EDIT_DOWNLINE = "/edit-downline";
    static _URL_DOWNLINE_GROUP_DETAIL = "/downline-group-detail";
    static _URL_Edit_Downline_Group_Detail = "/edit-downline-group-detail";
    static _URL_KPI = "/kpi";
    static _URL_REPORT = "/report";
    static _URL_GAME_RECORD = "/game-record";
    static _URL_WALLET_STATEMENT = "/wallet-statement";
    static _URL_STATEMENT = "/statement";
    static _URL_OLD_WALLET_STATEMENT = "/wallet-history";
    static _URL_ROLLOVER_STATEMENT = "/rollover-statement";
    static _URL_REWARDS = "/rewards";
    static _URL_REWARD_HISTORY = "/reward-history";
    static _URL_REWARDS_TNC = "/rewards-tnc";
    static _URL_BONUS_REPORT = "/bonus-report";
    static _URL_DEPOSIT_BONUS_HISTORY = "/deposit-bonus-history";
    static _URL_INTERNAL_TRANSFER_REPORT = "/internal-transfer-report";
    static _URL_ACCOUNT = "/account";
    static _URL_SETTINGS = "/settings";
    // static _URL_TERMS = "/terms-and-conditions";
    /*    static _URL_ABOUT = "/:category";*/
    static _URL_ABOUT_US = "/about-us";
    static _URL_TERMS_AND_CONDITIONS = "/info/terms-and-conditions";
    static _URL_PRIVACY_POLICY = "/privacy-policy";
    static _URL_AFFILIATE_PARTNER_PROGRAM = "/affiliate-partner-program";
    static _URL_RESPONSIBLE_GAMBLING = "/info/responsible-gambling";
    static _URL_VIP = "/vip-event";
    static _URL_SUMMARY_DOWNLINE = "/summary-downline";
    static _URL_REFERRAL = "/referral";
    static _URL_REFERRAL_CODE = "/referral-code";
    static _URL_REFERRAL_EDIT = "/referral-edit";
    static _URL_DOWNLOAD_APP = "/download-app";
    static _URL_VIDEO_TUTORIAL = "/video-tutorial";
    static _URL_4D_RESULT = "/4d-result";
    static _URL_CONTACT_US = "/contact-us";
    static _URL_LIVE_CHAT = "/live-chat";
    static _URL_REGISTER = "/register";
    static _URL_HELP_CENTRE = "/help-centre";
    static _URL_HELP_CENTRE_CATEGORY = "/help-centre/:category";
    static _URL_HELP_CENTRE_SUB_CATEGORY = "/help-centre/:category/:sub_category";
    static _URL_HELP_CENTRE_FAQ = "/help-centre/:category/:sub_category/:faq";
    static _URL_GAME_PAGE = "/game-page";
    static _URL_GAME_LIST = "/games/:provider";
    static _URL_DOWNLOAD = "/download";
    static _URL_CLAIM_HISTORY = "/claim-history";
    static _URL_PROVIDER_LOBBY = "/game/:category/:provider?";

    static providerLobbyUrl(category) {
        return WebUrl._URL_PROVIDER_LOBBY
            .replace(":category", category)
            .replace(":provider?", "");
    }

    static _URL_SLOT = "/slots";
    static _URL_ESPORT = "/esports";
    static _URL_RNG = "/rng";
    static _URL_CONNECT = "/connect";
    static _URL_LOTTERY = "/lottery";
    static _URL_POKER = "/poker";
    static _URL_SPORT = "/sports";
    static _URL_CASINO = "/casino";
    static _URL_RICHWIN_ADMIN = "/richwin-admin";
    static _URL_COMMISSION_HISTORY = "/commission-history";
    static _URL_UNCLAIM_COMMISSION_HISTORY = "/unclaim-commission-history";
    static _URL_WALLET_TRANSFER_HISTORY = "/wallet-transfer-history";
    static _URL_DEPOSIT_RECORD = "/deposit-record";
    static _URL_WITHDRAWAL_RECORD = "/withdrawal-record";
    static _URL_LOYALTY_REDEMPTION = "/loyalty-redemption";
    static _URL_LOYALTY_REDEMPTION_HISTORY = "/loyalty-redemption-history";
    static _URL_LOYALTY_REDEMPTION_TNC = "/loyalty-redemption-tnc";
    static _URL_UNCLAIM_LOYALTY_POINTS = "/unclaim-loyalty-points";
    static _URL_LOYALTY_POINTS_HISTORY = "/report/loyalty-points-history";
    static _URL_LOYALTY_VOUCHER_DETAILS = "/loyalty-voucher-details";
    static _URL_COCK_FIGHTING = "/cockfighting";
    static _URL_DEPOSIT_NEW = "/deposit-new";
    static _URL_DAILY_CHECK_IN = "/daily-check-in";
    static _URL_PROMOTION = "/promotion";
    static _URL_MEMBER_PRODUCT_RATE_DETAIL = "/product-rate-detail";
    static _URL_GAME_PROVIDER_LIST = "/game-provider-list";
    static _URL_PUSAT_INFO = "/pusat-info";
    static _URL_FAQ = "/info/faq";
    static _URL_HOW_TO_PLAY = "/info/how-to-play";
    static _URL_CONTENT_REFERRAL = "/info/referral";
    static _URL_REGISTER_NEW = "/register-new";
    static _URL_MY_PROMO = "/my-promo";
    static _URL_DEPOSIT_RECORD_UG = "/deposit-record-ug";
    static _URL_WITHDRAWAL_RECORD_UG = "/withdrawal-record-ug";
    static _URL_TRANSFER_RECORD_UG = "/transfer-record-ug";
    static _URL_LAST_TRANSACTION = "/last-transaction";
    static _URL_SPIN_WHEEL = "/lucky-spin";
    static _URL_CONGRATS = "/congrats";
    static _URL_REGISTER_SUCCESS = "/register-success";
    static _URL_INACTIVE_DOWNLINE = "/inactive-downline";
    static _URL_TOTAL_COMMISION = "/total-commision-reward";
    static _URL = "/total-commision-reward";
    static _URL_MEMBER_BENEFIT_PAGE = "/member-benefit";
}

/// <summary>
/// Author :
/// </summary>
export class Status {
    static _ENABLED = 1;
    static _DISABLED = 0;
    static _DELETED = 2;
}

/// <summary>
/// Author :
/// </summary>
export class Language {
    static _CHINESE = "zh";
    static _ENGLISH = "en";
    static _BAHASA_MELAYU = "ms";
    //static _BANGLADESH = "bn";
    static _THAI = "th";
    static _VIETNAMESE = "vi";
    static _INDON = "id";
}

/// <summary>
/// Author :
/// </summary>
export class SessionKey {
    static _LANGUAGE = "language";
    static _LOGIN_GUID = "loginGuid";
    static _ISSHOWMINIGAMETRIGGER = "isShowMiniGameTrigger";
    static _ISONLOAD = 'isOnload';
}

/// <summary>
/// Author :
/// </summary>
export class Role {
    static _SUPER_ADMIN = 1;
    static _SHOP = 2;
    static _MANAGER = 3;
    static _MEMBER = 4;
    static _ADMIN_SUB_ACCOUNT = 0;
}

/// <summary>
/// Author : -
/// </summary>
export class TransactionType {
    static _DEPOSIT = 1;
    static _WITHDRAWAL = 2;
    static _BONUS = 3;
    static _ADJUSTMENT = 4;
    static _REBATE = 5;
    static _TRANSFER = 6;
    static _REFERRALBONUS = 7;
    static _REFUND = 8;
    static _FREESPIN = 12;
    static _VOUCHER = 13;
}

/// <summary>
/// Author : -
/// </summary>
export class TransactionStatus {
    static _OPEN = 0;
    static _IN_REVIEW = 1;
    static _IN_PROGRESS = 2;
    static _APPROVED = 3;
    static _REJECTED = 4;
    static _AUTO_APPROVED = 5;
}

/// <summary>
/// Author: -
/// </summary>
export class InputValidationKey {
    static _REQUIRED_KEY = "required";
    static _MAX_LENGTH_KEY = "maxLength";
    static _MIN_LENGTH_KEY = "minLength";
}

/// <summary>
/// Author: -
/// </summary>
export class AlertTypes {
    static _DEFAULT = "default";
    static _INFO = "info";
    static _SUCCESS = "success";
    static _WARNING = "warning";
    static _DANGER = "danger";
    static _ERROR = "error";
    static _INPUT = "input";
    static _CUSTOM = "custom";
}

/// <summary>
/// Author: -
/// </summary>
export class FilterStatus {
    static _ACTIVE = 1;
    static _DELETED = 2;
    static _SUSPENDED = 0;
}

/// <summary>
/// Author: -
/// </summary>
export class LoginType {
    static _LOGIN_TYPE_SHOP = 2;
    static _LOGIN_TYPE_ADMIN = 1;
}

/// <summary>
/// Author: -
/// this is match db value, do not change
/// </summary>
export class TopUpStatus {
    static _PENDING = 0;
    static _SUCCESS = 1;
    static _FAILED = 2;
}

/// <summary>
/// Author: -
/// </summary>
export class CommonStatus {
    static _ALL_STATUS = -1;
    static _PENDING_STATUS = 0;
    static _APPROVE_STATUS = 1;
    static _REJECT_STATUS = 2;
    static _INACTIVE_STATUS = 3;
}

export class TransferType {
    static _DEFAULT = "Default";
    static _CONVERT_POINTS = "Convert Points";
    static _BANK = "Bank";
    static _DOWNLINE = "Downline";
    static _UPLINE = "Upline";
}

/// <summary>
/// Author : -
/// </summary>
export class BankingChannel {
    static _CHANNEL_OFFLINE_BANKING = 1;
    static _CHANNEL_PAYTRUST = 2;
    static _CHANNEL_GPAY = 3;
}

export class BankingDepositType {
    static _BANK = 1;
    static _EWALLET = 2;
    static _PULSA = 3;
}

/// <summary>
/// Author : -
/// </summary>
export class PanelType {
    static _MEMBERSITE = "MemberSite";
    static _MOBILESITE = "MobileSite";
    static _BACKOFFICE = "BackOffice";
    static _APPS = "Apps";
    static _SYSTEM = "Systems";
}

/// <summary>
/// Author : -
/// </summary>
export class BetStatus {
    static _PENDING_BET_STATUS = 0;
    static _SETTLED_BET_STATUS = 1;
    static _CANCELED_BET_STATUS = 2;
}

/// <summary>
/// Author : -
/// </summary>
export class LanguageKey {
    static _PRIMARY = "common";
}

/// <summary>
/// Author : -
/// </summary>
export class PaymentType {
    static _PREPAID = 2;
    static _POSTPAID = 1;
}

/// <summary>
/// Author : -
/// this value have to match with backend
/// </summary>
export class DisplayDevice {
    static _DESKTOP_MAIN = 0;
    static _DESKTOP_SUB = 1;
    static _MOBILE_POPOUT = 2;
    static _MOBILE_SLIDER = 3;
    static _DESKTOP_POPUP = 4;
    static _HOMEPAGE_PROMO_MOBILE = 5;
    static _HOMEPAGE_PROMO_DESKTOP = 6;
    static _HOMEPAGE_BANNER_MOBILE_UG = 7;
    static _HOMEPAGE_BANNER_DESKTOP_UG = 8;
    static _MOBILE_BANNER_POPUP = 9;
    static _DESKTOP_BANNER_POPUP = 10;
    static _TELEGRAM_BANNER_MOBILE_MAIN = 20;
    static _TELEGRAM_BANNER_MOBILE_SECONDARY = 21;
    static _TELEGRAM_BANNER_DESKTOP = 22;
}

/// <summary>
/// Author : -
/// </summary>
export const _TICKET_STATUS = [
    { value: null, label: "ALL" },
    { value: "0", label: "PENDING" },
    { value: "1", label: "SETTLED" },
    { value: "2", label: "CANCELLED" },
];

/// <summary>
/// Author : -
/// </summary>
export const _MAIN_WALLET_ID = 0;

/// <summary>
/// Author : Wong
/// </summary>
export const LanguageOption = [
    {
        prefix: "EN",
        value: Language._ENGLISH,
        icon: "/img/CountryFlag/EN.png",
        code: "en",
        languageId: 1,
        name: "ENGLISH"
    },
    {
        prefix: "中文",
        value: Language._CHINESE,
        icon: "/img/CountryFlag/CN.png",
        code: "zh",
        languageId: 2,
    },
    {
        prefix: "MY",
        value: Language._BAHASA_MELAYU,
        icon: "/img/CountryFlag/BM.png",
        code: "ms",
        languageId: 3,
    },
    //{
    //  prefix: "BD",
    //  value: Language._BANGLADESH,
    //  icon: "/img/CountryFlag/BD.png",
    //  code: "bn",
    //  languageId: 4,
    //},,
    {
        prefix: "TH",
        value: Language._THAI,
        icon: "/img/CountryFlag/TH.png",
        code: "th",
        languageId: 5,
    },
    {
        prefix: "VI",
        value: Language._VIETNAMESE,
        icon: "/img/CountryFlag/VN.png",
        code: "vi",
        languageId: 6,
    },
    {
        prefix: "ID",
        value: Language._INDON,
        icon: "/img/CountryFlag/ID.png",
        code: "id",
        languageId: 7,
        name: "BHS INDONESIA"
    },
];

export const PhoneNumberPrefix = [
    {
        label: "+62",
        countryCode: "ID",
        value: "62",
    },
    {
        label: "+60",
        countryCode: "MY",
        value: "60",
    },
    {
        label: "+66",
        countryCode: "TH",
        value: "66",
    },
    {
        label: "+84",
        countryCode: "VI",
        value: "84",
    },
    {
        label: "+61",
        countryCode: "AU",
        value: "61",
    },
];

export const FixedDepositAmount = [
    10000,
    50000,
    100000,
    500000,
    1000000
];

export const FixedDepositAmount2 = [
    10,
    50,
    100,
    500,
    1000
];

export const LanguageSelectStyle = {
    control: (styles, state) => ({
        width: "60px",
        padding: ".5rem",
        borderRadius: "4px",
        background: "rgba(0, 0, 0, 0.3)",
    }),
    placeholder: (provided, state) => ({
        color: "#fff",
        margin: "0 auto",
    }),
    dropdownIndicator: (defaultStyles) => ({
        display: "none",
    }),
    indicatorsContainer: (defaultStyles) => ({
        display: "none",
    }),
    option: (provided, state) => ({
        fontSize: "12px",
        textAlign: "center",
        marginTop: "3px",
        marginBottom: "2px",
        padding: ".5rem 1rem",
        color: "#002e6c",
    }),
};

export const DEFAULT_PAGE_SIZE = 10;

export const KEY = "ck8kVwFzA6OI79s394MpPUZTOZJtiR5LHCCR80xNaSo=";

export const _CURRENCY_RATIO = 1000;

export const hostnamePixelMapping = {
    'i8gacor.click': '7885882604862648',
    'm.i8gacor.click': '7885882604862648',
    'i8livemantap.online': '1176218490348600',
    'm.i8livemantap.online': '1176218490348600',
    'i8livesuskes.online': '1460233147992475',
    'm.i8livesuskes.online': '1460233147992475',
    'i8livetop.online': '863826108525054',
    'm.i8livetop.online': '863826108525054',
};

export const hostnameExoMapping = {
    'lovei8.com': '9DNnDRbt',
    'm.lovei8.com': '9DNnDRbt',
};

export const hostnameCodeMapping = {
    'localhost': 'EzNm0b3m',
    'idv2-preproduction.huat8id.com': 'EzNm0b3m',
    'idv2-preproduction-d.huat8id.com': 'EzNm0b3m',
    'i8gacor.click': 'EzNm0b3m',
    'm.i8gacor.click': 'EzNm0b3m',
    'i8live01.click': 'EzNm0b3m',
    'm.i8live01.click': 'EzNm0b3m',
    'i8live01.cyou': 'EzNm0b3m',
    'm.i8live01.cyou': 'EzNm0b3m',
    'i8live01.homes': 'EzNm0b3m',
    'm.i8live01.homes': 'EzNm0b3m',
    'i8live01.lol': 'EzNm0b3m',
    'm.i8live01.lol': 'EzNm0b3m',
    'i8live01.makeup': 'EzNm0b3m',
    'm.i8live01.makeup': 'EzNm0b3m',
    'i8livemantap.online': 'Fphp66jf',
    'm.i8livemantap.online': 'Fphp66jf',
    'i8livesuskes.online': 'iABPz2m2',
    'm.i8livesuskes.online': 'iABPz2m2',
    'i8livetop.online': 'ahxWsBt7',
    'm.i8livetop.online': 'ahxWsBt7',
    'lovei8.com': '9DNnDRbt',
    'm.lovei8.com': '9DNnDRbt',
    'i8live01.autos': 'EzNm0b3m',
    'm.i8live01.autos': 'EzNm0b3m',
    'i8live01.beauty': 'EzNm0b3m',
    'm.i8live01.beauty': 'EzNm0b3m',
    'i8live01.boats': 'EzNm0b3m',
    'm.i8live01.boats': 'EzNm0b3m',
    'i8live01.cfd': 'EzNm0b3m',
    'm.i8live01.cfd': 'EzNm0b3m',
    'i8live01.mom': 'EzNm0b3m',
    'm.i8live01.mom': 'EzNm0b3m',
    'i8live01.motorcycles': 'EzNm0b3m',
    'm.i8live01.motorcycles': 'EzNm0b3m',
    'i8live01.pics': 'EzNm0b3m',
    'i8live01.bond': 'EzNm0b3m',
    'i8live01.digital': 'EzNm0b3m',
    'i8live01.icu': 'EzNm0b3m',
    'i8live01.online': 'EzNm0b3m',
    'm.i8live01.pics': 'EzNm0b3m',
    'm.i8live01.bond': 'EzNm0b3m',
    'm.i8live01.digital': 'EzNm0b3m',
    'm.i8live01.icu': 'EzNm0b3m',
    'm.i8live01.online': 'EzNm0b3m',
    'link1-m.i8ucantik.com': 'EzNm0b3m',
    'link1-m.i8utampan.com': 'EzNm0b3m',
    'link1-m.i8live01.quest': 'EzNm0b3m',
    'link1-m.i8live01.rest': 'EzNm0b3m',
    'link1-m.i8live01.sbs': 'EzNm0b3m',
    'link1-m.i8live01.site': 'EzNm0b3m',
    'link1-m.i8live01.shop': 'EzNm0b3m',
    'link1.i8ucantik.com': 'EzNm0b3m',
    'link1.i8utampan.com': 'EzNm0b3m',
    'link1.i8live01.quest': 'EzNm0b3m',
    'link1.i8live01.rest': 'EzNm0b3m',
    'link1.i8live01.sbs': 'EzNm0b3m',
    'link1.i8live01.site': 'EzNm0b3m',
    'link1.i8live01.shop': 'EzNm0b3m',
    'link1.i8liveair.site': 'rwbi1vWj',
    'link1.i8livepro.site': 'iABPz2m2',
    'link2.i8livepro.site': 'iABPz2m2',
    'link3.i8livepro.site': 'iABPz2m2',
    'link1.i8livepromax.site': 'ahxWsBt7',
    'link2.i8livepromax.site': 'ahxWsBt7',
    'link2.i8live01.rest': 'EzNm0b3m',
    'link3.i8live01.rest': 'EzNm0b3m',
    'link4.i8live01.rest': 'EzNm0b3m',
    'link5.i8live01.rest': 'EzNm0b3m',
    'link1-m.i8liveair.site': 'rwbi1vWj',
    'link1-m.i8livepro.site': 'iABPz2m2',
    'link2-m.i8livepro.site': 'iABPz2m2',
    'link3-m.i8livepro.site': 'iABPz2m2',
    'link1-m.i8livepromax.site': 'ahxWsBt7',
    'link2-m.i8livepromax.site': 'ahxWsBt7',
    'link2-m.i8live01.rest': 'EzNm0b3m',
    'link3-m.i8live01.rest': 'EzNm0b3m',
    'link4-m.i8live01.rest': 'EzNm0b3m',
    'link5-m.i8live01.rest': 'EzNm0b3m',
    'link2.i8liveair.site': 'rwbi1vWj',
    'link3.i8liveair.site': 'rwbi1vWj',
    'link4.i8liveair.site': 'rwbi1vWj',
    'link5.i8liveair.site': 'rwbi1vWj',
    'link6.i8live01.rest': 'EzNm0b3m',
    'link7.i8live01.rest': 'EzNm0b3m',
    'link8.i8live01.rest': 'EzNm0b3m',
    'link9.i8live01.rest': 'EzNm0b3m',
    'link10.i8live01.rest': 'EzNm0b3m',
    'i8premium.com': 'E90m2fMH',
    'm.i8premium.com': 'E90m2fMH',
    'preproduction.i8premium.com': 'E90m2fMH',
    'preproduction-d.i8premium.com': 'E90m2fMH',
};

export const _I8LIVE_INDONESIA_REFERRAL_CODE = 'Si4h4JTQ';
export const _I8LIVE_INDONESIA_PIXEL_ID = '1536755074504774';

const _I8LIVE_INDONESIA_MOBILE_MIRROR_REGEX = /^.+-m\.i8liveindonesia\.com$/;
const _I8LIVE_INDONESIA_DESKTOP_SUBDOMAIN_REGEX = /^(?!m\.i8liveindonesia\.com$)(?!.+-m\.i8liveindonesia\.com$)[a-zA-Z0-9-]+\.i8liveindonesia\.com$/;

export const matchesI8LiveIndonesiaHostname = (hostname) => {
    if (hostname === 'i8liveindonesia.com') return true;
    if (hostname === 'm.i8liveindonesia.com') return true;
    if (_I8LIVE_INDONESIA_MOBILE_MIRROR_REGEX.test(hostname)) return true;
    if (_I8LIVE_INDONESIA_DESKTOP_SUBDOMAIN_REGEX.test(hostname)) return true;
    return false;
};

export const getHostnameReferralCode = (hostname) => {
    if (hostnameCodeMapping[hostname]) {
        return hostnameCodeMapping[hostname];
    }
    if (matchesI8LiveIndonesiaHostname(hostname)) {
        return _I8LIVE_INDONESIA_REFERRAL_CODE;
    }
    return undefined;
};

export const getHostnamePixelId = (hostname) => {
    if (hostnamePixelMapping[hostname]) {
        return hostnamePixelMapping[hostname];
    }
    if (matchesI8LiveIndonesiaHostname(hostname)) {
        return _I8LIVE_INDONESIA_PIXEL_ID;
    }
    return undefined;
};
